import { atom } from "jotai";

import { currentModalStepAtom } from "../stores";

export const goToCancelBookingStepAtom = atom(null, (_get, set) => {
  set(currentModalStepAtom, { type: "CancelBooking" });
});
